import { atom } from "jotai";

// 読み込み中かどうか
const isLoading = atom<boolean>(true);

// パス
const pathname = atom<string>("");

// key
const apiKey = atom<string>("");

// システム特定用のキー
const display = atom<string>("");

// 事前入力のキー
const inputID = atom<string>("");

// スマートフォン表示
const isSmartPhone = atom<boolean>(false);

// レイアウト表示設定
const layoutStatus = atom<string>("loading");

// レイアウト詳細
const layoutConfig = atom<{
  site_color: string;
  site_layout: string;
  site_title: string;
  site_footer: string;
  service_page_url: string;
  header_location_logo: string;
  trial_period_months: string;
  service_option_name_pull_down: string;
  service_option_name_check_box: string;
  service_required_optional_pull_down: string;
  service_required_optional_check_box: string;
  view_service_site: "0" | "1";
  outside_cancell_form_text: string;
  outside_cancell_form_mail_address: string;
}>({
  site_color: "",
  site_layout: "",
  site_title: "",
  site_footer: "",
  service_page_url: "",
  header_location_logo: "",
  trial_period_months: "",
  service_option_name_pull_down: "",
  service_option_name_check_box: "",
  service_required_optional_pull_down: "",
  service_required_optional_check_box: "",
  view_service_site: "1",
  outside_cancell_form_text: "",
  outside_cancell_form_mail_address: "",
});

// レイアウト（PDF）一覧
const pdfDatas = atom<
  {
    header_location_pdf: string;
    site_pdf_name: string;
    site_pdf_agree: string;
    site_pdf_footer: string;
  }[]
>([]);

// 事前登録した顧客情報
const beforeInputCustomerInfo = atom<{
  [key: string]:
    | string
    | {
        [key: string]: string;
      };
}>({});

// 支払方法
const paymentMethod = atom<
  {
    type: "j-payment" | "sbpayment-softbank" | "sbpayment-kddi";
    name: string;
  }[]
>([]);

// サービス - プルダウン
const pullDownService = atom<
  {
    id: number;
    service_name: string;
    value: number;
    tax: number;
  }[]
>([]);

// サービス - チェックボックス
const checkBoxService = atom<
  {
    id: number;
    service_name: string;
    value: number;
    tax: number;
  }[]
>([]);

// 質問一覧
const options = atom<
  {
    option_name: string;
    required_optional: number;
    option_type: number;
    option_comment: string;
    option_default_value: string;
    change_value_conf: number;
    tel_flg: number;
    name_flg: number;
    company_name_flg: number;
    zip_code_flg: number;
    address_flg: number;
    space_flg: number;
    mail_address_flg: number;
    form_tel_flg: number;
    multi_text_flg: number;
    half_width_number_flg: number;
    option_select: string[];
    depend_service_names: string[];
    depend_option_name: string;
    depend_select_names: string[];
  }[]
>([]);

export const AppAtoms = {
  isLoading,
  pathname,
  apiKey,
  display,
  inputID,
  isSmartPhone,
  layoutStatus,
  beforeInputCustomerInfo,
  layoutConfig,
  pdfDatas,
  paymentMethod,
  pullDownService,
  checkBoxService,
  options,
};
